import axios from '../axios/axios-auth'

export default class RealtimeService {

    requestAdditionalData(vehicleId, vehicleDeviceMac) {
        return axios.get('/api/v1/realtime/vehicle/' + vehicleId + '/device/' + vehicleDeviceMac).then(response => response.data)
    }

    requestDataLme(data) {
        return axios.post('/lme-service/v1/realTimeLme', data).then(response => response.data)
    }


}
